import React, { useCallback, useState, useEffect } from "react"
import { Container, Row, Label, FormFeedback, CardBody, Card } from "reactstrap"
import { useDropzone } from "react-dropzone"
import { useFormik } from "formik"
import * as Yup from "yup"
import { uId } from "common/utility"
import * as XLSX from "xlsx";
import Bulk_upload_user from './Bulk_upload_user.xlsx';
import ToastDialog from "components/Common/ToastDialog";
import { callBulkFileUpload } from "../../../http/auth/signup"
import { useNavigate } from "react-router-dom"
import { uploadInquiryFile } from "helpers/UAM/inquiry.helper";
import BulkUamUsers from "./bulkUsersTable"
import { getSystemConfigurationByKey } from "helpers/UAM/systemConfig.helper";

const UploadBulkUser = () => {
    document.title = "Upload Bulk Users | DMS"
    const [uploadProgress, setUploadProgress] = useState(0)
    const [showTable, setShowTable] = useState(true)
    const errorMessage = null
    const [toastInfo, setToastInfo] = useState({ showToast: false })
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("user"));
    const [maxLimit, setMaxLimit] = useState(50)

    const onDrop = useCallback(acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        if (selectedFile) {
            validationFileUpload.setFieldValue("fileUpload", selectedFile)
            setUploadProgress(100)
        } else {
            validationFileUpload.setFieldValue("fileUpload", [])
        }
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    })

    useEffect(() => {
        getDataLimitFunc()
    }, [])

    const getDataLimitFunc = async () => {
        let limit = await getSystemConfigurationByKey({ key: 'Data_limit' })
        if (limit.status) {
            let max = JSON.parse(limit.data[0].configValue)
            max = max.bulk_order ? Number(max.bulk_user) : 50
            setMaxLimit(max)
        }
    }

    const validationFileUpload = useFormik({
        enableReinitialize: true,
        initialValues: {
            fileUpload: null,
        },
        validationSchema: Yup.object({
            fileUpload: Yup.mixed()
                .required("Please Uplaod File")
                .test(
                    "fileType",
                    "Invalid file type",
                    value => {
                        if (value) {
                            const allowedExtensions = [".xls", ".xlsx"];
                            const fileExtension = value.name
                                .split(".")
                                .pop()
                                .toLowerCase();
                            return allowedExtensions.includes(`.${fileExtension}`);
                        }
                        return true;
                    }

                ),
        }),
        onSubmit: values => {
            handleSheetData(values.fileUpload, async (json) => {
                let jsonData = json.json;
                let numColumns = json.numColumns;

                try {
                    if (!jsonData || jsonData.length === 0) {
                        showToast('Add Atleast One User');
                    } else if (jsonData.length > maxLimit) {
                        showToast(`Maximum limit of ${maxLimit} items exceeded. Please reduce the number of items.`);
                    } else if (numColumns !== 7) {
                        showToast('Invalid Form Data');
                    } else {
                        await handleFileUploadAndCall(values.fileUpload, jsonData);
                    }
                } catch (err) {
                    console.log(err);
                }
            });
        },
    });

    const showToast = (message, role = "error") => {
        setToastInfo({
            message,
            showToast: true,
            role,
        });
    };

    const handleSuccess = (message, batchId) => {
        setToastInfo({
            message,
            showToast: true,
            role: "success",
        });

        const encryptedId = btoa(batchId.toString());
        setTimeout(() => {
            navigate(`/${user.roleName}/listUserUploadStatus/list?id=${encodeURIComponent(encryptedId)}`);
        }, 1000);
        validationFileUpload.resetForm();
    };

    const handleError = (err) => {
        console.log(err);
    };

    const handleFileUploadAndCall = async (fileUpload, jsonData) => {
        try {
            const res = await handleFileUpload(fileUpload);

            if (res.status) {
                const uploadRes = await callBulkFileUpload({
                    filePath: res.path,
                    noOfRecords: jsonData.length,
                    fileData: jsonData,
                });

                if (uploadRes.status) {
                    handleSuccess(uploadRes.message.message, uploadRes.message.batchId);
                } else {
                    showToast(uploadRes.message, "error");
                }
            } else {
                showToast(res.path);
            }
        } catch (err) {
            handleError(err);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <div className='page-title-box d-flex gap-3 justify-content-between align-items-center'>
                    <h4 className="mb-sm-0 font-size-18">UPLOAD BULK USERS</h4>
                    <div>
                        <button
                            className="btn btn-outline-success"
                            type="button"
                            onClick={() => {
                                setShowTable(!showTable)
                            }}
                        >
                            {showTable ? (
                                <>
                                    <i className="bx bx-folder me-2"></i>
                                    Upload Users
                                </>
                            ) : (
                                <>
                                    Show File Status
                                </>
                            )}
                        </button>
                    </div>
                </div>
                <Card>
                    <CardBody>
                        <Row className="vertical-scroll">
                            {!showTable && (
                                <>
                                    <div
                                        style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
                                    >
                                        <div className="d-flex">
                                            <div>
                                                <h6>Download User Sample File:</h6>
                                            </div>
                                            <div
                                                style={{
                                                    backgroundColor: "#344fa0",
                                                    color: "white",
                                                    padding: "8px 10px 5px 10px",
                                                    borderRadius: "100%",
                                                    fontSize: "20px",
                                                    marginTop: "-12px",
                                                    cursor: "pointer",
                                                }}
                                                className="ms-2"
                                                onClick={() => {
                                                    downloadExcelFile()
                                                    setToastInfo({
                                                        message: 'File Downlaoded Successfully',
                                                        showToast: true,
                                                        role: "success",
                                                    })
                                                }}
                                            >
                                                <i className="bx bx-archive-in" />
                                            </div>
                                        </div>
                                    </div>
                                    <Row >
                                        <div className="bulk">
                                            <div className="bulkOrderUpload" style={{ gap: "1rem", padding: '2rem 0rem' }}>
                                                <div className="bulkOrderUploadImgdiv">
                                                    <img src="/bulkOrderUpload.svg" alt="file image " />
                                                </div>
                                                <div>
                                                    <div className="heading"> Upload Users </div>
                                                    <div>
                                                        <p>Upload your bulk Users.</p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="d-flex flex-column">
                                                        <Label
                                                            htmlFor="horizontal-email-Input"
                                                            className="required-sign"
                                                        >
                                                            {"Upload File ( .xlsx, xls)"}
                                                            <i className="mdi mdi-asterisk"></i>
                                                        </Label>
                                                        <div
                                                            className="drop"
                                                            style={{ padding: "1rem" }}
                                                            onKeyUp={() => { }}
                                                            onClick={() => {
                                                                validationFileUpload.touched.fileUpload = true
                                                            }}
                                                        >
                                                            <div {...getRootProps()} className="text-wrapper">
                                                                <div className="centered">
                                                                    <input
                                                                        type="file"
                                                                        name="formatDocument"
                                                                        id="itrFileExcel"
                                                                        accept=".jpg, .png, .jpeg, .pdf"
                                                                        {...getInputProps()}
                                                                    />
                                                                    <label
                                                                        style={{
                                                                            marginBottom: 0,
                                                                            fontSize: "14px",
                                                                        }}
                                                                    >
                                                                        {isDragActive && (
                                                                            <p className="textLink">Drop here</p>
                                                                        )}
                                                                        <span className="textLink">
                                                                            Browse files to attach
                                                                        </span>
                                                                        or Drop
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <label style={{ color: '#344fa0' }}>
                                                            {`Ensure Excel file data does not exceed ${maxLimit} records`}
                                                        </label>
                                                        {validationFileUpload.values.fileUpload && (
                                                            <>
                                                                <span className="mt-2" key={`file-${uId()}`}>
                                                                    {validationFileUpload.values.fileUpload.name}{" "}
                                                                </span>
                                                                {uploadProgress > 0 && !errorMessage && (
                                                                    <div className="progress mt-2">
                                                                        <div
                                                                            className="progress-bar bg-success"
                                                                            style={{ width: `${uploadProgress}%` }}
                                                                            aria-valuenow="0"
                                                                            aria-valuemin="0"
                                                                            aria-valuemax="100"
                                                                        >
                                                                            {`${uploadProgress}%`}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {errorMessage && (
                                                                    <div className="alert alert-danger mt-2">
                                                                        {errorMessage}
                                                                    </div>
                                                                )}{" "}
                                                            </>
                                                        )}

                                                        {validationFileUpload.submitCount > 0 &&
                                                            validationFileUpload.errors.fileUpload ? (
                                                            <FormFeedback type="invalid" style={{ display: "block" }}>
                                                                {validationFileUpload.errors.fileUpload}
                                                            </FormFeedback>
                                                        ) : null}
                                                        <div className="mt-2 d-flex gap-3 justify-content-end">
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                type="button"
                                                                onClick={() => { navigate(-1) }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button className="btn btn-success save-customer"
                                                                onClick={validationFileUpload.handleSubmit}
                                                                type="button"
                                                            >
                                                                Upload
                                                            </button>

                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            </div>
                                        </div>
                                    </Row>
                                </>
                            )}
                            {showTable && (
                                <BulkUamUsers />
                            )}
                        </Row>
                    </CardBody>
                </Card>
            </Container>
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </div >
    )
}

export default UploadBulkUser

const handleSheetData = (file, callback) => {
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            const numColumns = range.e.c - range.s.c + 1;
            const json = XLSX.utils.sheet_to_json(worksheet, {
                defval: null,
                raw: false,
            });
            callback({ json, numColumns });
        };

        reader.readAsBinaryString(file);
    } else {
        callback(null);
    }
};

function downloadExcelFile() {
    const link = document.createElement("a");
    link.href = Bulk_upload_user;
    link.download = "Bulk_upload_user.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const handleFileUpload = async (uploadedFile) => {
    if (!uploadedFile) return;
    const fileUploadApiRes = await uploadInquiryFile(uploadedFile);
    if (fileUploadApiRes.status) {
        return { path: fileUploadApiRes.data[0], status: true }
    }
    return { path: fileUploadApiRes.message || 'Something Went Wrong', status: false }
}